import { env } from '@/config/env'
import { useSessionStore } from '@/stores/useSessionStore'

export const WEB_SURVEY_REGISTRATION_PARTIES = [
  'Republican',
  'Democrat',
  'Independent',
  'Other',
] as const

export type WebSurveyRegistrationParty = (typeof WEB_SURVEY_REGISTRATION_PARTIES)[number]

export const WEB_SURVEY_DEFAULT_PARTY: WebSurveyRegistrationParty = 'Independent'

/**
 * BFP-1128 — Create Account dropdown + Home ineligibility banner.
 * Identity `/me` `webSurveyRegistrationTypeEnabled` is the source of truth
 * (Mongo `platform_configs.web_survey_registration_type_enabled`). Vite is
 * last-resort until `/me` loads; missing DB row defaults to true.
 */
export function isWebSurveyRegistrationTypeEnabled(): boolean {
  const fromSession = useSessionStore.getState().user?.webSurveyRegistrationTypeEnabled
  if (typeof fromSession === 'boolean') return fromSession
  return env.VITE_WEB_SURVEY_REGISTRATION_TYPE_ENABLED === true
}
